import ko from 'knockout';

export default class ViewModel {
  constructor() {
    this.selectedCampaigns = ko.observable();
    this.selectedAdgroups = ko.observable();

    this.copySetting = ko.observable(false);
    this.hide = ko.observable(false);
  }
}
